import { FunctionComponent } from "react";
import { cn } from "../../../utils/cn";

export interface SelectNothingFoundProps {
  className?: string;
}

/**
 * popup to show when nothing found
 */
export const SelectNothingFound: FunctionComponent<SelectNothingFoundProps> = ({
  className,
}) => {
  const css = cn(
    className,
    "relative cursor-default select-none py-2 px-4 text-gray-700",
  );
  return <div className={css}>Nothing found.</div>;
};
